/* InstallableAppPrivacyInformation.tsx generated by @compiled/babel-plugin v0.36.0 */
import _defineProperty from "@babel/runtime/helpers/defineProperty";
import _objectWithoutProperties from "@babel/runtime/helpers/objectWithoutProperties";
const _excluded = ["as", "style"];
import { forwardRef } from 'react';
import { ax, ix, CC, CS } from "@compiled/react/runtime";
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
import { ButtonClickedEvent, useAnalyticsEvents } from '@atlassian/mpac-analytics';
import { FinePrint } from '@atlassian/mpac-primitives';
import { MarketplacePartnerType } from '@atlassian/mpac-types/graphql-gateway-types';
import { ExternalLink } from '@atlassian/mpac-ui';
import { TEST_IDS } from './constants';
import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
const _ = "._syaz131l{color:var(--ds-text-subtlest,#626f86)}";
export const AnalyticsSubjectIds = {
  termsOfUse: 'termsOfUse',
  privacyPolicy: 'privacyPolicy',
  marketplaceTermsOfUse: 'marketplaceTermsOfUse'
};
const FinePrintStyled = forwardRef((_ref, __cmplr) => {
  let {
      as: C = FinePrint,
      style: __cmpls
    } = _ref,
    __cmplp = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/_jsxs(CC, {
    children: [/*#__PURE__*/_jsx(CS, {
      children: [_]
    }), /*#__PURE__*/_jsx(C, _objectSpread(_objectSpread({}, __cmplp), {}, {
      style: __cmpls,
      ref: __cmplr,
      className: ax(["_syaz131l", __cmplp.className])
    }))]
  });
});
if (process.env.NODE_ENV !== 'production') {
  FinePrintStyled.displayName = 'FinePrintStyled';
}
const MissingPolicyWarning = _ref2 => {
  let {
    partnerName,
    privacyPolicyUrl,
    eula
  } = _ref2;
  if (privacyPolicyUrl && eula) {
    return null;
  }
  if (privacyPolicyUrl && !eula) {
    return /*#__PURE__*/_jsx(FinePrintStyled, {
      children: "".concat(partnerName, " has not provided any terms of use explaining your rights to use the app or how\n        ").concat(partnerName, " may restrict your use of the app. By installing this app, you acknowledge and\n        agree that ").concat(partnerName, " may restrict or prohibit your use of the app at any time.")
    });
  }
  if (!privacyPolicyUrl && eula) {
    return /*#__PURE__*/_jsx(FinePrintStyled, {
      children: "".concat(partnerName, " has not provided a privacy policy explaining how this app will use your data.\n        By installing this app, you acknowledge and agree this app may have unrestricted use of your\n        data. If you do not agree, you should not install this app.")
    });
  }
  return /*#__PURE__*/_jsx(FinePrintStyled, {
    children: "This vendor has not provided terms of use or a privacy policy explaining how they will use\n      your data. By installing this app, you acknowledge and agree this app may have unrestricted\n      use of your data and/or ".concat(partnerName, " may restrict or prohibit your use of the app at any\n      time. If you do not agree, you should not install this app.")
  });
};
const TermsOfUse = _ref3 => {
  let {
    appName,
    links,
    partnerName,
    onExternalLinkClick,
    privacyPolicyUrl,
    eula
  } = _ref3;
  const marketplaceTermsOfUse = /*#__PURE__*/_jsxs(_Fragment, {
    children: [/*#__PURE__*/_jsx("li", {
      children: "You permit Atlassian to share anonymized data with ".concat(appName)
    }), /*#__PURE__*/_jsxs("li", {
      children: ["You agree to Atlassian Marketplace's ", /*#__PURE__*/_jsx(ExternalLink, {
        href: links.marketplaceTermsOfUse.expand({}),
        onClick: () => onExternalLinkClick(AnalyticsSubjectIds.marketplaceTermsOfUse),
        "data-testid": AnalyticsSubjectIds.marketplaceTermsOfUse,
        children: "terms of use"
      })]
    })]
  });
  const partnerTermsOfUse = /*#__PURE__*/_jsxs("li", {
    children: ["You agree to ".concat(partnerName, "'s "), eula && /*#__PURE__*/_jsx(ExternalLink, {
      href: eula,
      onClick: () => {
        onExternalLinkClick(AnalyticsSubjectIds.termsOfUse);
      },
      "data-testid": AnalyticsSubjectIds.termsOfUse,
      children: "terms of use"
    }), eula && privacyPolicyUrl && /*#__PURE__*/_jsx(_Fragment, {
      children: " and "
    }), privacyPolicyUrl && /*#__PURE__*/_jsx(ExternalLink, {
      href: privacyPolicyUrl,
      onClick: () => onExternalLinkClick(AnalyticsSubjectIds.privacyPolicy),
      "data-testid": AnalyticsSubjectIds.privacyPolicy,
      children: "privacy policy"
    })]
  });
  return /*#__PURE__*/_jsxs(FinePrintStyled, {
    children: ["By installing this app:", /*#__PURE__*/_jsxs("ul", {
      children: [marketplaceTermsOfUse, (eula || privacyPolicyUrl) && partnerTermsOfUse]
    })]
  });
};
export const InstallableAppPrivacyInformation = _ref4 => {
  let {
    links,
    appName,
    partner,
    privacyPolicyUrl,
    endUserLicenseAgreementUrl,
    appIdentifier
  } = _ref4;
  const fireAnalyticsEvent = useAnalyticsEvents();
  const {
    name: partnerName,
    type: partnerType
  } = partner || {};
  const onExternalLinkClick = actionSubjectId => {
    fireAnalyticsEvent({
      actionSubjectId,
      eventType: ButtonClickedEvent,
      objectType: 'app',
      objectId: appIdentifier
    });
  };
  if (partnerType === MarketplacePartnerType.AtlassianInternal) {
    return null;
  }
  if (!partnerName) {
    return /*#__PURE__*/_jsx(FinePrintStyled, {
      "data-testid": TEST_IDS.INSTALLABLE_APP_PRIVACY_INFORMATION,
      children: "This third party vendor has not provided a privacy policy or terms of use. Atlassian's Privacy Policy is not applicable to the use of this app."
    });
  }
  return /*#__PURE__*/_jsxs("div", {
    "data-testid": TEST_IDS.INSTALLABLE_APP_PRIVACY_INFORMATION,
    children: [/*#__PURE__*/_jsx(TermsOfUse, {
      eula: endUserLicenseAgreementUrl,
      privacyPolicyUrl: privacyPolicyUrl,
      partnerName: partnerName,
      appName: appName,
      links: links,
      onExternalLinkClick: onExternalLinkClick
    }), /*#__PURE__*/_jsx(MissingPolicyWarning, {
      partnerName: partnerName,
      privacyPolicyUrl: privacyPolicyUrl,
      eula: endUserLicenseAgreementUrl
    })]
  });
};